import * as types from '../mutation-types'
import api from '../api'

const getDefaultState = () => {
    return {
        loyaltyPrograms: [],
        newSubscriptionInfos: null,
        lps: [],
        pointsUpdateSimulation: null
    }
}

const state = getDefaultState()

const mutations = {
    [types.LOYALTY_PROGRAMS_RECEIVED] (state, payload) {
        state.loyaltyPrograms = payload
    },

    [types.LOYALTY_PROGRAM_NEW_SUBS_INFOS_RECEIVED] (state, payload) {
        state.newSubscriptionInfos = payload
    },

    [types.LOYALTY_PROGRAM_SUBSCRIBED_CUSTOMERS] (state, payload) {
        state.lps = payload
    },

    [types.LOYALTY_PROGRAM_POINTS_COUNT_SIMULATION_UPDATED] (state, payload) {
        state.pointsUpdateSimulation = payload
    },

    [types.LOYALTY_PROGRAM_POINTS_COUNT_SIMULATION_RESET] (state) {
        state.pointsUpdateSimulation = null
    },
}

const actions = {
    fetchLoyaltyPrograms ({ commit }) {
        return api.getLoyaltyPrograms().then( response => {
            commit(types.LOYALTY_PROGRAMS_RECEIVED, response.data.loyalty_programs)
        })
    },

    fetchNewSubscriptionInfos ({ commit }, params) {
        return api.getNewSubscriptionInfos(params).then( response => {
            commit(types.LOYALTY_PROGRAM_NEW_SUBS_INFOS_RECEIVED, response.data)
        })
    },

    addNewLoyaltyProgramSubscription ({ commit, dispatch }, params) {
        return api.storeNewLoyaltyProgramSubscription(params).then( response => {
            if (response.status === 200) {
                const newParams = {
                    customer_id: params.customer_id,
                    programs: [],
                    statuses: []
                }
                dispatch('customer/fetchLoyaltyProgramSubscriptions', newParams, { root: true })
            }
        })
    },

    fetchLoyaltyProgramSubscribedCustomers ({ commit }, params) {
        return api.getCustomersSubscribedLoyaltyProgram(params).then( response => {
            commit(types.LOYALTY_PROGRAM_SUBSCRIBED_CUSTOMERS, response.data)
        })
    },

    terminateCustomerLoyaltyProgramSubscription ({ commit, dispatch }, params) {
        return api.terminateCustomerLoyaltyProgramSubscription(params).then( response => {
            if (response.status === 202) {
                dispatch('customer/fetchLoyaltyProgramSubscriptions', { customer_id: params.customerId }, { root: true })
            }
        })
    },

    disableCustomerLoyaltyProgramSubscription ({ commit, dispatch }, params) {
        return api.disableCustomerLoyaltyProgramSubscription(params).then( response => {
            if (response.status === 202) {
                dispatch('customer/fetchLoyaltyProgramSubscriptions', { customer_id: params.customerId }, { root: true })
            }
        })
    },

    enableCustomerLoyaltyProgramSubscription ({ commit, dispatch }, params) {
        return api.enableCustomerLoyaltyProgramSubscription(params).then( response => {
            if (response.status === 202) {
                dispatch('customer/fetchLoyaltyProgramSubscriptions', { customer_id: params.customerId }, { root: true })
            }
        })
    },

    updateCustomerLoyaltyProgramSubscription ({ commit, dispatch }, params) {
        return api.updateCustomerLoyaltyProgramSubscription(params).then( response => {
            console.log(response)
            if (response.status === 200) {
                commit(types.LOYALTY_PROGRAM_POINTS_COUNT_SIMULATION_UPDATED, response.data)
            }
            if (response.status === 202) {
                dispatch('customer/fetchLoyaltyProgramSubscriptions', { customer_id: params.customerId }, { root: true })
            }
        })
    },
}

const getters = {}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./client/store/modules/loyaltyPrograms.js